import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const EcommExclamationMarkHexagonIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M7.32681 1.46967C7.46747 1.32902 7.65823 1.25 7.85714 1.25H16.1429C16.3418 1.25 16.5325 1.32902 16.6732 1.46967L22.5303 7.32681C22.671 7.46747 22.75 7.65823 22.75 7.85714V16.1429C22.75 16.3418 22.671 16.5325 22.5303 16.6732L16.6732 22.5303C16.5325 22.671 16.3418 22.75 16.1429 22.75H7.85714C7.65823 22.75 7.46747 22.671 7.32681 22.5303L1.46967 16.6732C1.32902 16.5325 1.25 16.3418 1.25 16.1429V7.85714C1.25 7.65823 1.32902 7.46747 1.46967 7.32681L7.32681 1.46967ZM8.1678 2.75L2.75 8.1678V15.8322L8.1678 21.25H15.8322L21.25 15.8322V8.1678L15.8322 2.75H8.1678Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
          <path
            d="M11 16C11 15.4477 11.4457 15 11.9955 15H12.0045C12.5543 15 13 15.4477 13 16 13 16.5523 12.5543 17 12.0045 17H11.9955C11.4457 17 11 16.5523 11 16zM12 13C11.4477 13 11 12.5726 11 12.0455V6.95455C11 6.42736 11.4477 6 12 6 12.5523 6 13 6.42736 13 6.95455V12.0455C13 12.5726 12.5523 13 12 13z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
        </svg>
      </IconWrapper>
    )
  },
)
